export class RestoreAzureDiskRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerDiskId",
            "baseName": "providerDiskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AzureDiskRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureDiskRequest.attributeTypeMap;
    }
    constructor() {
    }
}
